<template>
  <div class="tab-body">
    <div class="search">
      <el-row>
        <el-col :span="2">
          <el-button type="primary" size="mini" v-has-permission-code-and="'003500300015'" v-if="state < 6666"
            @click="toSave()">全部暂存</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="danger" v-has-permission-code-and="'003500300015'" size="mini" v-if="state < 6666"
            @click="toOpt(1)">配置完成</el-button>
        </el-col>
        <el-col :span="2">
          <el-button type="danger" v-has-permission-code-and="'003500300030'" v-if="state == 6666 && fftext" size="mini"
            @click="toOpt(2)">{{ fftext }}</el-button>
        </el-col>
        <el-col :span="1">
          <el-button type="success" v-has-permission-code-and="'003500300015'" size="mini" v-if="state < 6666"
            @click="toOpt(3)">+社保</el-button>
        </el-col>
        <el-col :span="2">
          <el-button size="mini" v-if="state < 6666" v-has-permission-code-and="'003500300015'" type="warning"
            @click="toOpt(4)">-社保</el-button>
        </el-col>
        <el-col :span="6" class="box">
          <div class="box2">
            <el-button type="primary" size="mini" @click="search(-11)" v-if="navi.prev">
              《《
            </el-button>
            <el-date-picker size="mini" v-model="mth" type="month" placeholder="选择月" value-format="yyyy-MM"
              @change="search(1)">
            </el-date-picker>

            <el-button type="primary" size="mini" @click="search(11)" v-if="navi.next">》》</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="operator">
      <span> {{ msg }}</span>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData" stripe border height="auto" @selection-change="selectionChange"
        v-loading="listLoading">
        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
        <el-table-column width="45" label="序">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column width="80" label="月份">
          <template slot-scope="scope">
            {{ scope.row.satm }}
          </template>
        </el-table-column>
        <el-table-column width="90" prop="name" label="姓名">
          <template slot-scope="scope">
            <el-tag size="mini" :title="scope.row.dy">{{
              scope.row.name
            }}</el-tag>
          </template></el-table-column>
        <el-table-column width="110" prop="allsal" label="税前工资">
        </el-table-column>
        <el-table-column width="90" prop="pssb" label="个人社保">
        </el-table-column>
        <el-table-column width="90" prop="dwsb" label="公司社保">
        </el-table-column>
        <el-table-column width="110" prop="gesui" label="个人所得税"><template slot-scope="scope">
            <el-input :readonly="readonly || scope.row.state >= 6666" size="mini" v-model="scope.row.gesui"
              autocomplete="off"></el-input></template></el-table-column>
        <el-table-column width="90" prop="salary" label="税后工资">
        </el-table-column>

        <el-table-column width="90" prop="state" label="状态"><template slot-scope="scope">
            <el-tag size="mini" type="warning" v-if="scope.row.state == 6000">计算中</el-tag>
            <el-tag size="mini" v-if="scope.row.state == 6666">计算完毕</el-tag>
            <el-tag size="mini" type="success" v-if="scope.row.state == 8888">已发</el-tag>
          </template></el-table-column>
        <el-table-column width="100" prop="gzpay" label="发:公账">
          <template slot-scope="scope">
            <el-tag size="mini" type="danger">{{
              scope.row.gzpay
            }}</el-tag></template>
        </el-table-column>
        <el-table-column width="100" prop="szpay" label="发:私账"><template slot-scope="scope">
            <el-input :readonly="readonly || scope.row.state >= 6666" size="mini" v-model="scope.row.szpay"
              autocomplete="off"></el-input> </template></el-table-column>
        <el-table-column width="100" prop="gjjpay" label="发:公积金"><template slot-scope="scope">
            <el-input :readonly="readonly || scope.row.state >= 6666" size="mini" v-model="scope.row.gjjpay"
              autocomplete="off"></el-input> </template></el-table-column>
        <el-table-column width="100" prop="bxpay" label="发:报销"><template slot-scope="scope">
            <el-input :readonly="readonly || scope.row.state >= 6666" size="mini" v-model="scope.row.bxpay"
              autocomplete="off"></el-input> </template></el-table-column>
        <el-table-column width="250" prop="remark" label="发工资备注"><template slot-scope="scope">
            <el-input size="mini" :readonly="readonly || scope.row.state >= 6666" v-model="scope.row.remark"
              autocomplete="off"></el-input> </template></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from "@/api/cw/salary.js";
export default {
  name: "paysal",
  components: {},
  data() {
    return {
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      allIds: [],
      payIds: [],
      selected: [],
      mth: "",
      ndcq: 22,
      selected2: 0,
      msg: "",
      me: {},
      readonly: true,
      navi: {},
      state: 0,
      fftext: ''
    };
  },
  watch: {
    listData: {
      handler() {
        for (let i = 0; i < this.listData.length; i++) {
          let d = this.listData[i];

          d.allsal = (
            d.bsal * 1 +
            d.kqsal * 1 +
            d.kou * 1 +
            d.yeji1 * 1 +
            d.yeji2 * 1 +
            d.yeji3 * 1 +
            d.jxkh * 1 +
            d.othsal * 1
          ).toFixed(1);

          d.salary = Math.floor(d.allsal * 1 + d.pssb * 1 + d.gesui * 1);
          d.gzpay = d.salary - d.szpay * 1 - d.gjjpay * 1 - d.bxpay * 1;
        }
      },
      deep: true,
    },
  },
  methods: {
    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams);

      api.toPay(params, (res) => {
        this.listData = res.data.datas;
        // 可以导航的月份
        this.navi = res.data.navi;
        this.state = res.data.state;
        this.mth = new Date(this.navi.crnt.replaceAll("-", "/") + "/01");
        this.allIds = [];
        for (let i = 0; i < this.listData.length; i++) {
          let vo = this.listData[i];
          this.allIds.push(vo.id);
        }
        if (!this.listData || this.listData.length == 0) {
          this.$utils.msg.success("该月没有数据");
        }
        this.listLoading = false;
      });
    },
    //去添加
    toSave() {
      api.save(this.listData, (res) => {
        this.$utils.msg.success(res.msg);
        this.list();
      });
    },
    //审批
    toOpt(type) {
      if (type == 1) {
        // state 6000->6666
        api.save(this.listData, (res) => {
          this.$utils.confirm.warning("提示", "工资放发配置完成？", () => {
            this.list();
            api.sp(
              this.allIds,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
              }
            );
          });
        });
      } else if (type == 2) {
         if (this.payIds.length === this.selected.length) {
          this.$utils.confirm.warning("提示", "确定已发放？", () => {
            api.sp(
              this.payIds,
              (res) => {
                this.$utils.msg.success(res.msg);
                this.list();
              },
              (res) => {
                this.$utils.msg.warning(res.msg);
              }
            );
          });
        }else{
          this.$utils.msg.warning("选中的行中存在已发放数据!");
        }

      } else {
        if (!this.selected || this.selected.length == 0) {
          this.$utils.msg.info("请配置社保选择至少一行");
          return;
        }
        if (type == 3) {
          this.$utils.confirm.warning("提示", "确定购买社保吗？", () => {
            api.addSb(
              this.selected,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
              }
            );
          });
        } else if (type == 4) {
          this.$utils.confirm.warning("提示", "确定不买社保吗？", () => {
            api.rmSb(
              this.selected,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
              }
            );
          });
        }
      }
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      this.payIds = [];
      let sumSq = 0; //税前
      let sumSh = 0; //税后
      let sumSb = 0; //社保合计
      let cntSb = 0; //社保人数
      let sumGs = 0; //个税
      let sumSz = 0; //私账出
      let sumGz = 0; //公账全部 （公账工资+报销）
      let sumBx = 0;
      let dwsb = 0;

      for (let item of val) {
        this.selected.push(item.id);

        if (item.state * 1 == 6666) {
          this.payIds.push(item.id);
        }

        sumSq += item.allsal * 1;
        sumSh += item.salary * 1;
        sumSb += (item.dwsb - item.pssb) * 1;
        if (item.dwsb > 0) {
          cntSb++;
          dwsb = item.dwsb;
        }
        sumGs += item.gesui * -1;
        sumSz += item.szpay * 1;
        sumGz += item.gzpay * 1;
        sumBx += item.bxpay * 1;
      }

      if (this.selected.length > 0) {

        if (this.selected.length == this.listData.length) {
          this.fftext = "全部发放"
        } else {
          this.fftext = "部分发放"
        }

        this.msg =
          "已选择: " +
          this.selected.length +
          " 人,  税前 " +
          sumSq.toFixed(0) +
          " 元,税后" +
          sumSh.toFixed(0) +
          " 元。  社保【" +
          cntSb +
          "】人合计 " +
          sumSb.toFixed(0) +
          " 元。个税: " +
          sumGs.toFixed(2) +
          " 元。  公账发 :(工资) " +
          sumGz.toFixed(0) +
          " +(报销) " +
          sumBx.toFixed(0) +
          " =" +
          (sumGz + sumBx).toFixed(0) +
          " 元。  私账发: " +
          sumSz.toFixed(0) +
          " 元。  当月总人工: " +
          (sumSq + cntSb * dwsb).toFixed(0) +
          " 元。";
      } else {
        this.msg = "";
        this.fftext = ""
      }
    }, //搜索
    search(type) {
      if (type) {
        if (type == -11) {
          //上1月
          this.searchParams.mth = this.navi.prev;
        } else if (type == 11) {
          //下1月
          this.searchParams.mth = this.navi.next;
        } else if (type == 1) {
          // 时间选择器
          this.searchParams.mth = this.month;
        }
      }
      this.list();
    },
  },
  mounted() {
    this.me = this.$caches.user.get();
    if (this.me.role2 == "admin") {
      this.readonly = false;
    }
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";

.operator {
  margin-top: 10px;
}
</style>

